import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TablaOrdenesComponent } from './paginas/tabla-ordenes/tabla-ordenes.component';
import { ImportarOrdenesComponent } from './paginas/importar-ordenes/importar-ordenes.component';
import { FilaOrdenTablaPipe } from './paginas/importar-ordenes/utilidades/importar-ordenes.pipes';
import { VerOrdenComponent } from './paginas/ver-orden/ver-orden.component';
import { CancelarOrdenComponent } from './componentes/cancelar-orden/cancelar-orden.component';
import { OrdenesTablaPipe } from './utilidades/ordenes.pipes';
import { CrearOrdenComponent } from './paginas/crear-orden/crear-orden.component';
import { PrepararOrdenComponent } from './componentes/preparar-orden/preparar-orden.component';
import { PrepararOrdenesComponent } from './paginas/preparar-ordenes/preparar-ordenes.component';
import { ImprimirEtiquetasComponent } from './paginas/imprimir-etiquetas/imprimir-etiquetas.component';
import { RecogerOrdenesComponent } from './paginas/recoger-ordenes/recoger-ordenes.component';

import { OrdenesRoutingModule } from './ordenes-routing.module';
import { TablaAsincronaModule } from '../compartido/tabla-asincrona/tabla-asincrona.module';
import { AutorizacionModule } from '../nucleo/autorizacion/autorizacion.module';
import { TablaModule } from '../compartido/tabla/tabla.module';
import { FichaModule } from '../compartido/ficha/ficha.module';
import { FormularioModule } from '../compartido/formulario/formulario.module';
import { LectorCodigosComponent } from '../compartido/lector-codigos/lector-codigos.component';
import { DatosDireccionComponent } from '../clientes/componentes/datos-direccion/datos-direccion.component';
import { DatosOrdenComponent } from './componentes/datos-orden/datos-orden.component';
import { DatosDomicilioComponent } from '../domicilios/componentes/datos-domicilio/datos-domicilio.component';
import { DatosClienteComponent } from '../clientes/componentes/datos-cliente/datos-cliente.component';
import { DatosFormulaComponent } from './componentes/datos-formula/datos-formula.component';
import { DatosItemComponent } from './componentes/datos-item/datos-item.component';
import { HistorialOrdenComponent } from './componentes/historial-orden/historial-orden.component';

import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [
    TablaOrdenesComponent,
    ImportarOrdenesComponent,
    FilaOrdenTablaPipe,
    VerOrdenComponent,
    CancelarOrdenComponent,
    OrdenesTablaPipe,
    CrearOrdenComponent,
    PrepararOrdenComponent,
    PrepararOrdenesComponent,
    ImprimirEtiquetasComponent,
    RecogerOrdenesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,

    OrdenesRoutingModule,
    TablaAsincronaModule,
    AutorizacionModule,
    TablaModule,
    FichaModule,
    FormularioModule,
    LectorCodigosComponent,
    DatosDireccionComponent,
    DatosOrdenComponent,
    DatosDomicilioComponent,
    DatosClienteComponent,
    DatosFormulaComponent,
    DatosItemComponent,
    HistorialOrdenComponent,

    MatStepperModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatListModule,
    MatInputModule,
    MatTabsModule,
  ],
  exports: [ImprimirEtiquetasComponent],
})
export class OrdenesModule {}
